import React, { useState } from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";

import { ImCross } from "react-icons/im";
import { GoChevronLeft } from "react-icons/go";
import { GoChevronRight } from "react-icons/go";

import {
  TransformWrapper,
  TransformComponent,
} from "@kokarn/react-zoom-pan-pinch";

import Pagination from "@mui/material/Pagination";
import { DialogContent, Dialog } from "@mui/material";
export default function NoDetections(props) {
  // pop for image showing
  const [open, setOpen] = useState(false);

  // const [fullWidth, setFullWidth] = useState(true);
  // const [maxWidth, setMaxWidth] = useState("sm");
  // const EmptyData = props.data;
  const noDetectionData = props.data;
  const store = props.store;

  const handleImgError = (e) => {
    e.target.src = "no_detections";
  };

  const all_img_url = [];
  // eslint-disable-next-line
  for (const [key, value] of Object.entries(noDetectionData)) {
    var date_data = value;

    // eslint-disable-next-line
    for (const [key, value] of Object.entries(date_data)) {
      let storewise_data = value;
      for (let i = 0; i < storewise_data["no_detections"].length; i++) {
        all_img_url.push(storewise_data["no_detections"][i]);
      }
    }
  }

  const pageLimit = 6;
  const [totalpage] = useState(Math.ceil(all_img_url.length / pageLimit));
  const [page, setPage] = useState(1);
  const pageChangeHandle = (event, pageNumber) => {
    setPage(pageNumber);
  };

  const lastpage = pageLimit * page;
  const fisrtPage = lastpage - pageLimit;
  const allData = all_img_url.slice(fisrtPage, lastpage);
  const [zoomImage, setZoomImage] = useState(0);

  const openCardView = (e, index) => {
    e.preventDefault();
    // setCardViewIsActive(!cardViewIsActive);

    const totalCount = 5 * page;
    const totalIndex = totalCount + (page - 1);

    // console.log("index", index);

    setZoomImage(totalIndex - (5 - index));
    setOpen(true);
  };

  const leftClick = () => {
    // console.log("start Process");
    if (zoomImage > 0) {
      setZoomImage(zoomImage - 1);
    }
  };

  const rightClick = () => {
    // console.log("start Process");

    if (zoomImage < all_img_url.length - 1) {
      setZoomImage(zoomImage + 1);
    }
  };

  const handleClose = () => setOpen(false);

  // THIS FUNCTION USE FOR
  function getStoreName(storeId) {
    const filterStore = store.filter((store) => {
      return store._id === storeId;
    });
    return filterStore[0].name;
  }
  //  let pop_image = "";

  // if( zoomImage=== undefined){
  //    setZoomImage(0)
  // }
  // console.log("zoom", zoomImage);
  // pop_image=allData[zoomImage].img_url

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return (
    <>
      {allData.length === 0 ? (
        <div>No image available</div>
      ) : (
        <div>
          {!allData ? (
            <></>
          ) : (
            <>
              <div>
                <ImageList
                  // sx={{ width: "500", height: "550" }}
                  cols={2}
                  gap={10}
                  variant="woven"
                  rowHeight="auto"
                >
                  {allData.map((val, id) => (
                    <button onClick={(e) => openCardView(e, id)}>
                      <ImageListItem key={id}>
                        <img
                          src={val.img_url}
                          alt="No detection images"
                          loading="lazy"
                          onError={handleImgError}
                        />

                        <ImageListItemBar
                          className="text-left	"
                          title={<span>Fullness: {val.fullness}</span>}
                          subtitle={
                            new Date(val.date).getDate() +
                            "-" +
                            monthNames[new Date(val.date).getMonth()]
                          }
                        />
                      </ImageListItem>
                    </button>
                  ))}
                </ImageList>
                <Dialog
                  // fullWidth={fullWidth}
                  // maxWidth={maxWidth}
                  fullScreen
                  open={open}
                  onClose={handleClose}
                  PaperProps={{
                    sx: {
                      width: "100%",
                      maxHeight: "1300px",
                      background: "black",
                      boxShadow: "none",
                    },
                  }}
                >
                  <DialogContent className="w-full h-full flex justify-center relative overflow-hidden">
                    {open === true ? (
                      allData && (
                        <div className="self-center">
                          <ImCross
                            onClick={handleClose}
                            className="z-20 text-xl cursor-pointer text-white opacity-60 hover:opacity-100 absolute"
                            style={{
                              right: "4%",
                              top: "2%",
                            }}
                          />
                          <GoChevronLeft
                            onClick={leftClick}
                            className="text-white opacity-60 hover:opacity-100 text-7xl absolute z-10"
                            style={{
                              left: "2%",
                              top: "45%",
                            }}
                          />
                          <GoChevronRight
                            // onClick={setZoomImage((zoomImage+1))}
                            onClick={rightClick}
                            className="text-white opacity-60 hover:opacity-100 text-7xl absolute z-10"
                            style={{ right: "2%", top: "45%" }}
                          />
                          <div
                            id="rubikFont"
                            className="fixed top-4 px-4 left-0 w-full h-20 z-10 flex flex-col space-y-1 font-semibold 2xl:font-bold text-xl md:text-2xl 2xl:text-3xl"
                            style={{ background: "rgba(0, 0, 0, 0.3)" }}
                          >
                            <span className="text-white opacity-100">
                              {getStoreName(all_img_url[zoomImage].store)}
                            </span>
                            <span className="text-white opacity-100">
                              {all_img_url[zoomImage].brand_name}
                            </span>
                          </div>
                          <div
                            id="rubikFont"
                            className="fixed bottom-4 px-4 left-0 w-full h-20 z-10 flex flex-col space-y-1 font-semibold 2xl:font-bold text-xl md:text-2xl 2xl:text-3xl"
                            style={{ background: "rgba(0, 0, 0, 0.3)" }}
                          >
                            <span className="text-white opacity-100">
                              Fullness: {all_img_url[zoomImage].fullness}%
                            </span>
                            <span className="text-white opacity-100">
                              {new Date(all_img_url[zoomImage].date).getDate() +
                                "-" +
                                monthNames[
                                  new Date(
                                    all_img_url[zoomImage].date
                                  ).getMonth()
                                ] +
                                "-" +
                                new Date(
                                  all_img_url[zoomImage].date
                                ).getFullYear()}
                            </span>
                          </div>
                          <TransformWrapper>
                            <TransformComponent>
                              <img
                                className="self-center"
                                style={{ maxHeight: "95svh" }}
                                src={all_img_url[zoomImage].img_url}
                                alt="img not found"
                              />
                            </TransformComponent>
                          </TransformWrapper>
                        </div>
                      )
                    ) : (
                      <>no image found</>
                    )}
                  </DialogContent>
                </Dialog>

                <div className="w-11/12 m-auto flex justify-center pt-2   ">
                  <Pagination
                    className="min-w-max m-auto text-center     "
                    onChange={(event, pageNumber) =>
                      pageChangeHandle(event, pageNumber)
                    }
                    count={totalpage}
                    color="success"
                  />
                </div>
                {/* {noDetectionData.map((val,id) => (
                <div key={id}>
                  {Object.keys(val).map((data,Id) => (
                    <ImageList key={id} sx={{ width: 800, height: 550 }} cols={4} rowHeight={164}>
                      {val[data].no_detections.map((final,id) => (
                       <ImageListItem key={id}>
                      
                        
                           <img
                             src={final}
                             alt="Filled Images"
                             loading="lazy"
                             onError={handleImgError}
                           />
                     
                   
                       </ImageListItem>
       
                      ))}
                    </ImageList>
                  ))}
                </div>
              ))} */}
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
}
